// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CallToActionDashboard_wrapper__14BRW","text":"CallToActionDashboard_text__FGKvM","button":"CallToActionDashboard_button__pnEZF"};